import { reactive } from 'vue';

import i18n from '../plugins/i18n';

export const globalState = reactive({
  isLoading: false,
  locale: i18n.global.locale.value,
});
